var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ct-btn",class:{
    'ct-btn-default': !_vm.type,
    'ct-btn-primary': _vm.type === _vm.PRIMARY,
    'ct-btn-standard': _vm.size === _vm.STANDARD,
    'ct-btn-small': _vm.size === _vm.SMALL
  },on:{"click":_vm.handleBtnClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }